import Vue from 'vue'

// Global components
const requireContext = require.context('./', true, /.*\.js$/)
requireContext.keys().forEach(file => {
    requireContext(file)
})


// WEBPACK FOOTER //
// ./src/plugins/index.js